import { AutopilotSidebar as BaseAutopilotSidebar } from 'screens/VirtualMarketerOnboarding/AutopilotSidebar/AutopilotSidebar'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Best platforms for you',
          text: 'We picked the best platforms for your business. Add or remove channels as needed.',
        },
        {
          heading: 'Unsure which to pick?',
          text: "We'll help you choose the right mix. Book a quick 1:1 call with our team.",
        },
      ]}
    />
  )
}
